__turbopack_context__.v({
  "addressAdditional": "billing-address-module-scss-module__y7A0Vq__addressAdditional",
  "addressBreakdown": "billing-address-module-scss-module__y7A0Vq__addressBreakdown",
  "addressFormWrapper": "billing-address-module-scss-module__y7A0Vq__addressFormWrapper",
  "addressLine": "billing-address-module-scss-module__y7A0Vq__addressLine",
  "addressOptionsWrapper": "billing-address-module-scss-module__y7A0Vq__addressOptionsWrapper",
  "addressSection": "billing-address-module-scss-module__y7A0Vq__addressSection",
  "billingForm": "billing-address-module-scss-module__y7A0Vq__billingForm",
  "checked": "billing-address-module-scss-module__y7A0Vq__checked",
  "icon-american-express": "billing-address-module-scss-module__y7A0Vq__icon-american-express",
  "icon-arrow": "billing-address-module-scss-module__y7A0Vq__icon-arrow",
  "icon-chat": "billing-address-module-scss-module__y7A0Vq__icon-chat",
  "icon-cross": "billing-address-module-scss-module__y7A0Vq__icon-cross",
  "icon-discover": "billing-address-module-scss-module__y7A0Vq__icon-discover",
  "icon-mastercard": "billing-address-module-scss-module__y7A0Vq__icon-mastercard",
  "icon-visa": "billing-address-module-scss-module__y7A0Vq__icon-visa",
  "label": "billing-address-module-scss-module__y7A0Vq__label",
  "location": "billing-address-module-scss-module__y7A0Vq__location",
  "phone": "billing-address-module-scss-module__y7A0Vq__phone",
  "radioIcon": "billing-address-module-scss-module__y7A0Vq__radioIcon",
  "radioLabel": "billing-address-module-scss-module__y7A0Vq__radioLabel",
  "subHeading": "billing-address-module-scss-module__y7A0Vq__subHeading",
  "trade-mark": "billing-address-module-scss-module__y7A0Vq__trade-mark",
});
